import { useTranslation } from 'react-i18next';

import { ValidateCenterResponse } from '@/services/api';

interface ConfirmationDialogProperties {
  validationResponse: ValidateCenterResponse;
  onBack: () => void;
  onProceed: (validationResponse: ValidateCenterResponse) => void;
}

function LineComponent({ title, value }: { title: string; value: string | undefined }) {
  return (
    <div className="mb-4 flex flex-row">
      <div className="min-w-[160px] text-[0.9375em] font-[500] text-neutral-grey-3">{`${title}:`}</div>
      <div className="text-[1.1875em] font-semibold text-neutral-grey-4">{value}</div>
    </div>
  );
}

function Button({
  onClick,
  className,
  children,
}: {
  onClick: () => void;
  className: string;
  children: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      type="button"
      className={`h-[60px] w-[225px] rounded-[73px] px-4 py-2 text-[1.1875em] font-[600] text-primary-blue-3 ${className}`}
    >
      {children}
    </button>
  );
}

function ConfirmationDialog({
  validationResponse,
  onBack,
  onProceed,
}: ConfirmationDialogProperties) {
  const { t } = useTranslation(['centerValidation', 'translation']);
  const lines = [
    { title: `${t('translation:schoolName')}`, value: validationResponse?.centerName },
    { title: `${t('translation:schoolCode')}`, value: validationResponse?.centerCode },
    { title: `${t('translation:programCode')}`, value: validationResponse?.programCode },
  ];
  const onProceedHelper = () => onProceed(validationResponse);

  return (
    <div className="flex flex-col items-center">
      <div className="mb-8 flex w-full items-center">
        <img src="./icons/alert-icon.svg" alt="alert icon" className="mr-4 h-[40px] w-[40px]" />
        <h2 className="mr-16 text-center text-[1.4375em] font-[600] text-primary-blue-3">
          {t('centerValidation:confirmDetailsBeforeProceeding')}
        </h2>
      </div>
      <div className="w-full">
        {lines.map(({ title, value }) => (
          <LineComponent key={title} title={title} value={value} />
        ))}
      </div>
      <div className="flex w-full justify-center">
        <Button
          onClick={onBack}
          className="mr-6 border border-[3px] border-neutral-grey-2 bg-neutral-white"
        >
          {t('centerValidation:backText')}
        </Button>
        <Button
          onClick={onProceedHelper}
          className="font-boldshadow-md bg-primary-yellow-3 shadow-custom focus:outline-none"
        >
          {t('centerValidation:proceedText')}
        </Button>
      </div>
    </div>
  );
}

export default ConfirmationDialog;
